<template>
    <div class="page-bg login">
        <v-container fill-height justify-center>
            <div class="login-block">
                <div class="Client-logo">
                    <img :src="logo" class="Client-logo-img" />
                </div>
                <v-form class="login-frm">
                    <v-row>
                        <v-col cols="12" sm="12" class="pad-zero mr-bbt-10">
                            <v-text-field
                                @keydown.space.prevent
                                @focus="userclicked"
                                v-model="userName"
                                :disabled="true"
                                label="Email ID"
                                hide-details
                                dense
                                outlined
                                class="required"
                            ></v-text-field>
                            <InputError :data="error.userId" />
                        </v-col>
                        <v-col cols="12" sm="6" class="pad-zero mr-bbt-10">
                            <v-text-field
                                @keydown.space.prevent
                                type="password"
                                v-model="password"
                                label="New Password"
                                hide-details
                                dense
                                outlined
                                class="required"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" class="pad-zero mr-bbt-10">
                            <v-text-field
                                @keydown.space.prevent
                                type="password"
                                v-model="confirmPassword"
                                hide-details
                                label="Confirm Password"
                                dense
                                outlined
                                class="required"
                            ></v-text-field>
                            <InputError :data="error.errConfirmPassword" />
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero mr-bbt-10">
                            <PhoneNumber :blur="setMobileError" v-model="mobile" :code="code" :focus="inputFocused"></PhoneNumber>
                            <InputError :data="error.mobile" />
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <div class="signup-primary top-0">
                                <div class="user-new-signup"></div>
                                <div class="sign-up-btn">
                                    <v-btn
                                        @click="onGoClick"
                                        :disabled="canEnabled"
                                        class="right-btn cust-btn"
                                        color="primary"
                                    >Go</v-btn>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
                <div v-if="isDefaultInstitute && myInstitute && !myInstitute.is_white_labeled" class="power-logo">
                    <img src="@/assets/img/logo-footer.png" class="master-logo" />
                </div>
            </div>
        </v-container>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";
export default {
    name: "signup",
    data() {
        return {
            userName: "",
            password: "",
            confirmPassword: "",
            mobile: "",
            isValidUsername: null,
            logo: this.getInstituteLogo(),
            isInputFocused:false,
            error: {
                userId: {
                    type: null,
                    message: "",
                },
                errConfirmPassword: {
                    type: null,
                    message: null,
                },
                mobile: {
                    type: null,
                    message: "Please enter valid mobile number",
                },
            },
            code: ["+91"],
        };
    },
    created() {
        this.getCountryCodes();
    },
    computed: {
        ...mapState('userStore', ['isDefaultInstitute','user', 'myInstitute']),
        canEnabled() {
            return !(
                this.userName &&
                this.userName.trim().length &&
                this.password &&
                this.password.trim().length &&
                this.confirmPassword &&
                this.confirmPassword.trim().length
            );
        },
        isPasswordMatch() {
            return this.password === this.confirmPassword;
        },
    },
    watch: {
        userName(val) {
            if (!val || val.length < 1) {
                this.error.userId.type = null;
            }
        },
        password(val) {
            if (this.confirmPassword && this.confirmPassword.length) {
                this.setPasswordError(this.confirmPassword);
            }
        },
        confirmPassword(val) {
            this.setPasswordError(val);
        },
    },
    mounted(){
        this.userName = this.user.email
    },
    methods: {
        ...mapActions({
            // checkUserName: "userStore/checkUserName",
            createUserNameAndPassword: "userStore/createUserNameAndPassword",
            getCountryList: "utilStore/getCountryList",
        }),
        userclicked() {
            this.error.userId.type = null;
        },
        inputFocused(){
          this.isInputFocused=true;
        },
        setPasswordError(val) {
            if (!val || val.length === 0) {
                this.error.errConfirmPassword.type = null;
            } else if (this.isPasswordMatch) {
                this.error.errConfirmPassword.type = "success";
                this.error.errConfirmPassword.message = "Passwords match";
            } else {
                this.error.errConfirmPassword.type = "error";
                this.error.errConfirmPassword.message =
                    "Passwords do not match";
            }
        },
        // checkUserNameAvailability() {
        //     if (this.userName && this.userName.trim().length < 21) {
        //         this.checkUserName({ username: this.userName.trim() })
        //             .then((response) => {
        //                 this.isValidUsername = true;
        //                 this.error.userId.type = "success";
        //                 this.error.userId.message = "User ID available";
        //             })
        //             .catch((err) => {
        //                 this.isValidUsername = false;
        //                 this.error.userId.type = "error";
        //                 this.error.userId.message =
        //                     "This user ID is taken. Try another";
        //                 if (err && err.errors && err.errors.length) {
        //                     this.error.userId.message = err.errors[0].message;
        //                 }
        //             });
        //     } else{
        //         this.isValidUsername = false;
        //         this.error.userId.type = "error";
        //         this.error.userId.message ="User ID should not contain more than 20 characters";
        //     }
        // },
        setMobileError() {
            this.isInputFocused=false;
            if (
                this.mobile &&
                this.mobile.number &&
                this.mobile.number.length &&
                !this.isValidMobileNumber(this.mobile.number)
            ) {
                this.error.mobile.type = "error";
                this.error.mobile.message = "Please enter valid mobile number";
            } else {
                this.error.mobile.type = "null";
            }
        },
        onGoClick() {
            let reqData = {
                username: this.userName.trim(),
                password: this.confirmPassword.trim(),
                external:true
            };
            if (
                this.mobile &&
                this.mobile.number &&
                this.mobile.number.length &&
                !this.isValidMobileNumber(this.mobile.number)
            ) {
                this.setMobileError();
            } else if (this.isPasswordMatch) {
                if (
                    this.mobile &&
                    this.mobile.number &&
                    this.mobile.countryCode
                ) {
                    reqData.phone = this.getMobileNumberWithCountryCode(
                        this.mobile.countryCode,
                        this.mobile.number
                    );
                }
                this.$root.showLoader = true;
                this.createUserNameAndPassword(reqData)
                    .then((response) => {
                        this.$root.showLoader = false;
                        const user = this.user;
                        if (
                            user &&
                            user.institute !== this.ONLINE_INSTITUTE_ID &&
                            (user.role_id === constants.ROLES_ID.ST || user.role_id === constants.ROLES_ID.PA)
                        ) {
                            const token = sessionStorage.getItem('auth_token');
                            const userJson = sessionStorage.getItem('user');
                            const params = new URLSearchParams({ token, user: userJson });
                            const newProjectBase = window.location.hostname === 'localhost'
                                ? process.env.VUE_APP_NEW_PROJECT_URL
                                : window.location.origin + '/v2/';
                            window.location.href = newProjectBase + 'auto-login?' + params.toString();
                        } else {
                            this.$router.push({ name: "home" });
                        }
                    })
                    .catch((err) => {
                        this.$root.showLoader = false;
                    });
            }
        },
        getCountryCodes() {
            this.getCountryList({
                orderBy: { field: "dialingcode", order: "ASC" },
            })
                .then((response) => {
                    if (response && response.length) {
                        this.code = response.map((c) => {
                            return "+" + c.dialingcode;
                        });
                    }
                })
                .catch((err) => {});
        },
    },
};
</script>
